import { ContentState, EditorState } from "draft-js";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { premiumVoice, premiumVoices } from "../../../assets/premiumVoices";
import { StateAction, UserInterface } from "../actions/actions";

export const config = {
  "stripe_key": "pk_test_51IxlRJF32pO4iyiVpul6VTFptVNO3lacnvc3Z5i2JmzQDwtMQoJkbdD24qF12Ac6rDBQzpkfA6QPd90kORQjaEfz00f6fK8Jny",
  "maxFreeCharacters": 50000,
  "maxPremiumCharacters": 4000,
  "audioConvertUrl": "https://us-central1-audiobook-310902.cloudfunctions.net/audiobookApi/audio",
  "pdfParseUrl": "https://us-central1-audiobook-310902.cloudfunctions.net/pdfParser/pdftext",
  "getTextFromFileUrl": "https://getfiletext-2ev2dqebqa-uc.a.run.app/filetext",
  "getPremiumVoiceUrl": "https://us-central1-audiobook-310902.cloudfunctions.net/PremiumVoiceGetAudio/audio",
  "products": {
    "membership": {
      "monthly": "price_1IxmAWF32pO4iyiVxfpiFrCV",
      "yearly": "price_1IxmB3F32pO4iyiVbeheIFT3"
    },
    "characterPack": {
      "50000": "price_1J9QS7F32pO4iyiVssn2DbtG",
      "100000": "price_1JA3SFF32pO4iyiVrlWwM4vi",
      "250000": "price_1JA3XoF32pO4iyiVar3j7xZD",
      "500000": "price_1JA3YOF32pO4iyiV4xYIK8UN",
      "1000000": "price_1JA3YpF32pO4iyiVnilEp1Gf"
    }
  },
  "textByLanguage": {
    "exceededFree": "You have exceeded your daily limit of 50,000. Please buy a Nueral Voice Character Pack for more characters",
    "maxCharacterFreeErrorMessage": "Your text is over 50,000 characters! Free tier is limited to 50,000 characters for conversion from Text to Speech per day. Delete text to decrease the character count or buy a character pack to add more characters.",
    "exceededPremium": "You don't have enough Neural Characters for this conversion. Please buy a Nueral Voice Character Pack for more characters",
    "serverError": "There was an error on the server. Please try again later.",
    "signOut": "Sign Out",
    "free":"Free",
    "cancel": "Cancel",
    "ok": "Ok",
    "fileTypeNotSupported": "File type is not supported.",
    "whatIsTheLanguageInTheText":"What language is the text in the image",
    "mp3.title": "MP3 Format",
    "mp3.description": "(great quality, minimum size)",
    "wav.title": "Wav Format",
    "wav.description": "(best quality, largest size)",
    "pleaseSignIn": "Please sign up or login to use the premium Audio Anything service",
    "accept": "Accept",
    "welcome": "Welcome",
    "signedIn": "You are now signed in",
    "premiumTextTooLarge": "This text will take some time to convert, we will email you the download link when the conversion is complete.",
    "jobId": "Is your job id. A confirmation email has been emailed to you.",
    "priceBlockPoint.1": "Free Neural Voice credits.",
    "priceBlockPoint.2": "Access to over 200 voices in 40 languages",
    "priceBlockPoint.3": "Ability to adjust pitch and speaking rate",
    "priceBlockPoint.4": "Ability to choose between .wav or .mp3 audio format",
    "buyText": "Buy",
    "enterpriseSolution": "Enterprise Solution",
    "maxCharacterPremiumErrorMessage": "You do not have enough characters to convert this text. Buy a character pack to add more characters.",
    "pleaseBePatient": "Please be patient, this may take up to several minutes",
    "header.audioGenerator": "AUDIO GENERATOR",
    "header.pricing": "PRICING",
    "header.faq": "FAQ",
    "header.login": "LOGIN",
    "header.title": "Free Text To Speech",
    "header.summary": "Convert text from any file to natural sounding voice using the revolutionary Neural Voice Technology",
    "header.summary2": "Try out standard and neural voice technology voices!",
    "header.neuralVoiceTechnology": "Neural Voice Technology",
    "generator.step1": "Upload file or enter text below:",
    "generator.step1.supportedFileExtensions": "Supported File Extensions: ",
    "generator.upload": "UPLOAD",
    "generator.step2": "Select Voice Language",
    "generator.step2.basic": "BASIC",
    "generator.step2.neuralVoice": "NEURAL VOICE",
    "generator.step2.mp3Format": "MP3 Format",
    "generator.step2.mp3FormatDescription": "(great quality, minimum size)",
    "generator.step2.wavFormat": "WAV Format",
    "generator.step2.wavFormatDescription": "(best quality, largest size)",
    "generator.step2.speakingRate": "Speaking Rate",
    "generator.step2.pitch": "Pitch",
    "generator.step3": "Create Audio!",
    "generator.step3.createAudioButton": "CREATE AUDIO",
    "freeCharactersLeft": "Free Voice Characters Left",
    "neuralVoiceCharactersLeft": "Neural Voice Characters Left",
    "currentTextLength": "Current Text Length",
    "defaultEditorText": "Audio Anything is a free text to speech software that uses artificial intelligence and machine learning to generate authentic human voices. It support text to speech in over 200 voices and over 40 languages!",
    "audioPlayer.free": "Free",
    "audioPlayer.neuralVoice": "Neural Voice",
    "neuralVoiceCharacters": "Neural Voice Characters",
    "characterPack.title": "Character Packs",
    "characterPack.summary": "Choose a monthly subscription or pay as you go with character packs",
    "neuralCharacterDescription1": "Neural Voice credits.",
    "neuralCharacterDescription2": "Access to over 200 voices in 40 languages",
    "neuralCharacterDescription3": "Ability to adjust pitch and speaking rate",
    "neuralCharacterDescription4": "Ability to choose between .wav or .mp3 audio format",
    "characterPackButtonText": "BUY",
    "enterpriseSolutionContactUs": "Contact us to discuss custom solutions for your business",
    "enterpriseButtonText": "CONTACT US",
    "frequentlyAskedQuestions": "Frequently Asked Questions",
    "faqAccordionQ1": "What are the benefits of a premium membership?",
    "faqAccordionA1": "Access to over 200 natural sounding voices in over 40 languages!: Ability to save,view, and download previously converted audio files!: Access to voice speed and pitch tuning!: Free character pack which replenishes every month!",
    "faqAccordionQ2": "What is a Neural Voice?",
    "faqAccordionA2": "Neural text-to-speech (NTTS) model uses machine learning technologies to generate synthesized speech from text that sounds like a human voice. Using neural networks, it is now possible to produce very natural-sounding speech that includes different accents.",
    "faqAccordionQ3": "More Questions?",
    "faqAccordionA3": "Get in touch with us support@audioanything.com"
  }
}

export interface StateInterface {
  textToConvert: string;
  isFileConverting: boolean;
  loadingAudiobook: boolean;
  loadAudiobookError: boolean;
  pdfFile: File | null;
  pdfPreview: boolean;
  textEditorState: EditorState;
  pdfIsConverting: boolean;
  user: UserInterface | null;
  loginModal: boolean;
  mustBeLoggedInError: boolean;
  selectedLanguage: premiumVoice | string;
  selectedPremiumDemoVoice: premiumVoice | null;
  premiumVoiceAutoplay: boolean;
  apiErrorMessage: string;
  audioEncoding: "MP3" | "LINEAR16" | "OGG_OPUS";
  showImageLanguageOptions: boolean;
  apiMessage: string
  config: typeof config
}

export const defaultState: StateInterface = {
  textToConvert: config.textByLanguage.defaultEditorText,
  textEditorState: EditorState.createWithContent(
    ContentState.createFromText(config.textByLanguage.defaultEditorText)
  ),
  pdfFile: null,
  isFileConverting: false,
  loadingAudiobook: false,
  loadAudiobookError: false,
  pdfPreview: false,
  pdfIsConverting: false,
  user: null,
  loginModal: false,
  mustBeLoggedInError: false,
  selectedLanguage: "en",
  selectedPremiumDemoVoice: premiumVoices[16],
  premiumVoiceAutoplay: false,
  apiErrorMessage: "",
  audioEncoding: "MP3",
  showImageLanguageOptions: false,
  apiMessage: "",
  config


};

export const rootReducer = (
  state: StateInterface = defaultState,
  action: StateAction
): StateInterface => {
  switch (action.type) {
    case "SET_TEXT_TO_CONVERT":
      return { ...state, textToConvert: action.payload };
    case "START_CREATING_AUDIOBOOK":
      return { ...state, loadingAudiobook: true };
    case "FINISHED_CREATING_AUDIOBOOK":
      return { ...state, loadingAudiobook: false };
    case "SET_LOAD_AUDIOBOOK_ERROR":
      return { ...state, loadAudiobookError: !state.loadAudiobookError };
    case "SET_FILE":
      return { ...state, pdfFile: action.payload ? action.payload : null };
    case "SHOW_PDF_PREVIEW":
      return {
        ...state,
        pdfPreview: action.payload ? action.payload : !state.pdfPreview,
      };
    case "SET_TEXT_EDITOR_STATE":
      return {
        ...state,
        textEditorState: action.payload,
      };
    case "START_CONVERTING_FILE":
      return {
        ...state,
        pdfIsConverting: !state.pdfIsConverting,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_LOGIN_MODAL":
      return {
        ...state,
        loginModal: action.payload,
      };
    case "SET__USER_MUST_BE_LOGGED_IN_ERROR":
      return {
        ...state,
        mustBeLoggedInError: action.payload,
      };
    case "SET__SELECTED_LANGUAGE":
      return {
        ...state,
        selectedLanguage: action.payload,
      };
    case "SET_PREMIUM_DEMO_VOICE":
      return {
        ...state,
        selectedPremiumDemoVoice: action.payload,
      };
    case "SET_PREMIUM_DEMO_VOICE_AUTOPLAY":
      return {
        ...state,
        premiumVoiceAutoplay: action.payload,
      };
    case "SET_API_ERROR_MESSAGE":
      return {
        ...state,
        apiErrorMessage: action.payload,
      };
    case "SET_AUDIO_ENCODING":
      return {
        ...state,
        audioEncoding: action.payload,
      };
    case "SET_IS_FILE_CONVERTING":
      return {
        ...state,
        isFileConverting: action.payload,
      };
    case "SHOW_IMAGE_LANGUAGE_OPTIONS":
      return {
        ...state,
        showImageLanguageOptions: action.payload,
      };
    case "SET_API_MESSAGE":
      return {
        ...state,
        apiMessage: action.payload,
      };
    default:
      return state;
  }
};

export const store = createStore(rootReducer, applyMiddleware(thunk));
(window as any).store = store;
